import { marked } from 'marked'
import type { RouteLocationRaw } from '#vue-router'

const httpsRegex = /^(?:https?:)?\/\//i
const actionRegex = /^(?:mailto|tel):/i

function isPdf(href: string): boolean {
  try {
    return new URL(href).pathname.toLowerCase().endsWith('.pdf')
  } catch {
    return false
  }
}

export default defineNuxtPlugin(() => {
  marked.use({
    renderer: {
      link(src) {
        const attrs = []

        const href = src.href.trim()

        const isNetworkUrl = httpsRegex.test(href)
        const isActionUrl = actionRegex.test(href)
        const isExternal = isNetworkUrl || isActionUrl

        const hrefIsPdf = isPdf(href)

        if (isExternal || hrefIsPdf) {
          attrs.push(`href="${src.href}"`)
          attrs.push('target="_blank"')
          attrs.push('rel="noopener noreferrer"')

          if (hrefIsPdf) {
            attrs.push('download')
          }
        } else if (src.href.startsWith('/')) {
          attrs.push(`href="${src.href}"`)
        } else {
          const router = useRouter()
          const path = router.resolve({
            name: src.href
          } as RouteLocationRaw)
          attrs.push(`href="${path.href}"`)
        }

        return `<a ${attrs.join(' ')}>${src.text}</a>`
      }
    }
  })
})
